// extracted by mini-css-extract-plugin
export default {"Center":"global_Center__+T9dj","ButtonUnderline":"global_ButtonUnderline__nAc+c","Title":"global_Title__gT9g9","Subtitle":"global_Subtitle__v18nx"};